










































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { Account } from '@/modules/Account/interfaces/account'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import { dateTimeToDisplay, dateToNow } from '@/utils/dateTime'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class AccountDetailAdditional extends Vue {
  @Prop({ type: Object as () => Account }) readonly account!: Account

  dateTimeToDisplay = dateTimeToDisplay
  dateToNow = dateToNow
}
